
var id = "auth";
var markup = "<symbol viewBox=\"0 0 19 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"auth\">\n    <title>icon/content/how_to_reg_24px</title>\n    <defs>\n        <path d=\"M9,17 L12,14.06 C11.61,14.02 11.32,14 11,14 C8.33,14 3,15.34 3,18 L3,20 L12,20 L9,17 Z M11,12 C13.21,12 15,10.21 15,8 C15,5.79 13.21,4 11,4 C8.79,4 7,5.79 7,8 C7,10.21 8.79,12 11,12 L11,12 Z M15.47,20.5 L12,17 L13.4,15.59 L15.47,17.67 L20.6,12.5 L22,13.91 L15.47,20.5 Z\" id=\"auth_path-1\" />\n    </defs>\n    <g id=\"auth_Material-Icons-(filled)\" stroke=\"none\" stroke-width=\"1\" fill=\"\" fill-rule=\"evenodd\">\n        <g id=\"auth_34.-Icons/filled/content/how_to_reg_24px\" transform=\"translate(-3.000000, -4.000000)\">\n            <mask id=\"auth_mask-2\" fill=\"white\">\n                <use xlink:href=\"#auth_path-1\" />\n            </mask>\n            <use id=\"auth_icon/content/how_to_reg_24px\" fill-opacity=\"0.87\" fill=\"#1565C0\" xlink:href=\"#auth_path-1\" />\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
